import React from "react";
import styled from "styled-components";

const LoadingContainer = ({ show, opacity, top, borderRadius }) => {
  return (
    <OverlayContainer className={show === true ? "show" : ""} opacity={opacity} top={top} borderRadius={borderRadius}>
      <StyledLoadingIcon></StyledLoadingIcon>
    </OverlayContainer>
  );
};

export default LoadingContainer;

const OverlayContainer = styled.div.attrs((props) => ({
  opacity: props.opacity || 1,
  top: props.top || 0,
  borderRadius: props.borderRadius || 0,
}))`
  opacity: ${(props) => props.opacity};
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: ${(props) => props.top}px;
  left: 0;
  right: 0;
  background-color: #fff;
  opacity: 0.9;
  display: none;
  padding-top: 20px;
  box-sizing: border-box;
  border-radius: ${(props) => props.borderRadius}px;

  &.show {
    display: flex;
  }
`;

const StyledLoadingIcon = styled.div`
  border: 5px solid #ccc;
  border-top: 5px solid #eee;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: button-keyframe-spin 1s linear infinite;
  box-sizing: initial !important;
  position: sticky;

  @keyframes button-keyframe-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
